import React, { useRef, useState } from "react";
import { RCCButton, RCCDropDownItem, RCCGrid, RCCIcon, RCCInput, RCCTooltip } from "react-common-components";
import { IForwardPagination } from "react-common-components/dist/components/Pagination/interface";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import OptionsColumn from "src/components/DefaultColumnsList/Options";
import FiltersContainer from "src/components/FiltersContainer";
import PageTitle from "src/components/PageTitle";
import Pagination from "src/components/Pagination";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import { IRefAccessIPModals } from "./interface";
import Modals from "./modals";


const AccessIP: React.FC = () => {

	const { translate } = useTranslation();

	const [showFilters, setShowFilters] = useState(false);
	const [filters, setFilters] = useState<{ filter: string }>({ filter: "" });
	const [myIP, setMyIP] = useState<string | null>(null);
	const [showRegisterMyIP, setShowRegisterMyIP] = useState(false);
  

	const { handleSubmit : handleSubmitFilters, register : registerFilters, watch : watchFilters, reset: resetFilters } = useForm();

	const submitFilters = (data: any) => {
		setFilters({ filter: data.filter});
		paginationRef.current?.reload();
	};

	const paginationRef = useRef<IForwardPagination>(null);
	const modalRef = useRef<IRefAccessIPModals>(null);


	const colOptions = (row: any) => (
		<>
			<OptionsColumn>
				<RCCDropDownItem
					selfEnclose
					onClick={() => { modalRef.current?.actionButtonChange(row);  }}
				>
					<RCCIcon name="pencil" />
					{translate("Alterar")}
				</RCCDropDownItem>
				<RCCDropDownItem 
					selfEnclose
					onClick={() => { modalRef.current?.actionButtonDelete(row); }}
				>
					<RCCIcon name="trash" 
					/>
					{translate("Excluir")}
				</RCCDropDownItem>
			</OptionsColumn>
		</>
	);


	useEffectFetchData<string | null> (
		"AccessIp/ShowIp", undefined,
		 ({ data }) => {	 
			if(data && data !== ""){
				setMyIP(data);
				setShowRegisterMyIP(true);
			}
		}
	);
  
	return (
		<>
    	<RCCGrid
				container
				item
				direction="column"
			>
				{/* Header -> Results + Buttons */}
				<PageTitle
					title={translate("IP's de Acesso")}
					icon={() => <AppIcons name="configs" />}
				>
					<RCCTooltip
						text={translate("Adicionar IP de acesso")}
						color="purple"
					>
						<RCCButton
							icon={{name: "plus", color: "#FFF", size: 18}}
							color="purple"
							layout="isRounded"
							onClick={() => { 
								modalRef.current?.actionButtonAdd();
							}}
							size="md"
						/>
					</RCCTooltip>
					<RCCTooltip
						text={translate("Filtros")}
						color={showFilters || filters.filter ? "blue" : "grey"}
					>
						<RCCButton
							icon={{name: "filter", color: "#FFF", size: 16}}
							color={showFilters || filters.filter ? "blue" : "grey"}
							layout="isRounded"
							size="md"
							onClick={() => setShowFilters((prevState) => !prevState)}
						/>
					</RCCTooltip>
				</PageTitle>

				{/* Filters */}
				{showFilters && (
					<FiltersContainer
						onSubmitFilters={handleSubmitFilters(submitFilters)}
						resetFilters={() => resetFilters({
							filter: ""
						})}
					>
						<RCCGrid
							container 
							item
							xs={12}
							sm={6}
							md={4}
							lg={4}
						>
							<RCCInput
								name="filter" 
								label={translate("Pesquisar")}
								register={registerFilters}
								defaultValue={watchFilters("filter")}
							/>
						</RCCGrid>
					</FiltersContainer>
				)}

				<Title color="grey" size="xs" styleInline="flex-direction: column; align-items: flex-start; gap: 4px;">	
					{translate("Usuários do grupo Administradores não possuem restrição de IP")}
					<RCCGrid
						container
						item
						alignItems="center"
					>
						<p>{translate("No Cadastro de Usuário possui um configuração que permite escolher se deseja validar ou não o IP de acesso para cada usuário")}</p>
						<Link to="/users">
							<RCCTooltip
								text={translate("Usuários")}
								color="grey"
							>
								<RCCButton 
									color="transparent"
									icon={{
										name: "users",
										size: 14,
										color: "var(--input-font-color)"
									}}
								/>
							</RCCTooltip>
						</Link>
					</RCCGrid>
				</Title>	

				{showRegisterMyIP &&
            <>
            	<RCCGrid
            		container
            		item
            	>
            		<Title color="defaultColor">
            			{`${translate("Seu IP é")}: ${myIP}`}
            		</Title> 
            		<RCCTooltip
            			text={translate("Cadastrar")}
            			color="green"
            		>
            			<RCCButton
            				color="green"
            				icon={{
            					name: "plus"
            				}}
            				layout="isRounded"
            				size="xs"
            				onClick={() => modalRef.current?.registerIP({
            					efa024Ip: myIP,
            					efa024Observacao: ""
            				}, () => {
            					paginationRef.current?.reload();
            					setShowRegisterMyIP(false);
            				})}
            			/>
            		</RCCTooltip>
            	</RCCGrid>  
            </>
				}

				<Pagination 
					ref={paginationRef}
					dataOrRoute="AccessIp/List"
					filtersData={filters}     
					columns={[{
						idColumn: "efa024Ip",
						nameColumn: translate("Endereço de IP"),
						sm: 5,
						md: 5,
						type: "number"
	  			},{
						idColumn: "efa024Observacao",
						nameColumn: translate("Observação"),
						sm: 6,
						md: 6,
						type: "string",
						disableSort: true
	  			},{
						idColumn: "options",
						nameColumn: "",
						justify: "right",
						xs: 12,
						sm: 1,
						md: 1,
						cellRenderer: colOptions,
						disableSort: true
					}
					]}
				/>
			</RCCGrid>	

			<Modals 
				ref={modalRef}
				paginationRef={paginationRef}
			/>

		</>
	);
};

export default AccessIP;
